import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { HEADER_PADDING_HORIZONTAL_SMALL } from '@/styles';
import { HeaderRestaurantSelector } from './header-restaurant-selector';
import { Props as NavigationHeaderProps } from './navigation-header';
import { StyleProp, ViewStyle } from 'react-native';
import {
  useLayoutContext,
  useSmallLayoutSizeValue,
} from '@/contexts/layout-context';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useUserContext } from '@/contexts/user-context';

export const useHeaderRestaurantSelectorProps = (): NavigationHeaderProps => {
  const { isGuestMode } = useUserContext();
  const { isSmallLayout } = useLayoutContext();
  const [styles] = useStyles();
  const salesRepMode = useSalesRepMode();

  const containerStyle = useSmallLayoutSizeValue<StyleProp<ViewStyle>>(
    salesRepMode ? styles.containerDark : styles.container,
    styles.containerLarge,
  );

  return {
    containerStyle,
    contentContainerStyle: styles.contentContainer,
    contentHeader: isGuestMode ? undefined : <HeaderRestaurantSelector />,
    contentStyle: isSmallLayout ? styles.content : null,
  };
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.background,
  },
  containerDark: {
    backgroundColor: theme.colors.primary,
  },
  containerLarge: {
    backgroundColor: theme.colors.white,
  },
  content: {
    paddingHorizontal: HEADER_PADDING_HORIZONTAL_SMALL,
  },
  contentContainer: {
    backgroundColor: theme.colors.white,
    paddingHorizontal: 0,
  },
}));
